import { render, staticRenderFns } from "./SmplEditLaseChild.vue?vue&type=template&id=b8c2e79a&scoped=true&"
import script from "./SmplEditLaseChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditLaseChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditLaseChild.vue?vue&type=style&index=0&id=b8c2e79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c2e79a",
  null
  
)

export default component.exports